import { map, tap } from 'rxjs/operators';
import RESTClient from 'signin-app/api/clients/rest-client';
import { preparePinLoginResponse } from 'signin-app/pin/models';
import BehaviorsCollection from 'web-app/behaviors/behaviors-collection';
import { setLocale } from 'web-app/util/locale';
export default class DayCareApi {
    static pinLogin(pin) {
        return RESTClient.getAuthenticatedObservable('v2/checkin', {
            pin,
        }).pipe(map(response => {
            return preparePinLoginResponse(response);
        }));
    }
    static groups(accessToken) {
        return RESTClient.getObservable('daycare/tablet/overview', { accessToken }).pipe(tap(response => {
            var _a;
            if ((_a = response === null || response === void 0 ? void 0 : response.institution) === null || _a === void 0 ? void 0 : _a.locale) {
                setLocale(response.institution.locale);
            }
        }), map(response => {
            return {
                ...response,
                // Currently the backend renders response.behaviors without being clamped in an array if there is only one present.
                // This is just a quick work around for that which we should remove once they resolve it.
                behaviors: new BehaviorsCollection(response.behaviors ? [response.behaviors].flatMap(_ => _) : []),
            };
        }));
    }
    static employees(accessToken) {
        return RESTClient.getObservable('daycare/tablet/employees', {
            accessToken,
        });
    }
    static group(accessToken, groupId, institutionId, includeRelations) {
        return RESTClient.getObservable('daycare/tablet/group', {
            accessToken,
            groupId,
            institutionId,
            includeRelations,
        });
    }
    static child(accessToken, childId) {
        return RESTClient.getObservable('daycare/tablet/child', {
            accessToken,
            childId,
        });
    }
}
